import {INotificationsWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class PublicationMessageResolver implements Resolve<String[]> {

  constructor(private notificationsWebService: INotificationsWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    return this.notificationsWebService.getListModules();
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/message/publication/publication.message.resolver.ts